'use client'

import { useEffect } from 'react'

import CarRankingSection from './CarRankingSection'
import HomeAppCta from './HomeAppCta'
import HomeFooter from './HomeFooter'
import HomeHero from './HomeHero'
import HomeTopBar from './HomeTopBar'
import {
  HomeTrackingProvider,
  useHomeTracking,
} from '../_features/modoocar-home'

import type { TRankingMap } from '../_features/modoocar-home'

const ModoocarHomeContent = ({ rankingMap }: { rankingMap: TRankingMap }) => {
  const { pageShow } = useHomeTracking()

  // 페이지 진입 1회 (common_web_modoocar_page_show)
  useEffect(() => {
    pageShow()
  }, [pageShow])

  return (
    <div className='min-h-dvh bg-background-surface-basement'>
      <HomeTopBar />
      <div className='mx-auto w-full max-w-[640px]'>
        <div className='overflow-hidden bg-background-surface-default lg:mt-dimension-x4 lg:rounded-dimension-x6'>
          <HomeHero />
          <CarRankingSection rankingMap={rankingMap} />
          <HomeAppCta />
        </div>
        <HomeFooter />
      </div>
    </div>
  )
}

const ModoocarHome = ({ rankingMap }: { rankingMap: TRankingMap }) => (
  <HomeTrackingProvider>
    <ModoocarHomeContent rankingMap={rankingMap} />
  </HomeTrackingProvider>
)

export default ModoocarHome
